export enum StarterArticleSource {
  PET_MD = 'Pet MD',
  BE_CHEWY = 'Be Chewy',
}

export interface Article {
  title: string;
  image: string;
  link: string;
  logo?: string;
  source: StarterArticleSource;
}

export interface StarterArticles {
  title: string;
  articles: Article[];
}
